import React from 'react'
import Space from '../atoms/Space'
import { Text, View } from '../other/html'
import Price from '../molecules/Price'
import LikedSvg from '../other/svg/LikedSvg'
import BuyNowSvg from '../other/svg/BuyNowSvg'

const BrowseItemPlaceholder = (): JSX.Element => {
  return (
    <View className="pt-2 pb-1 h-[342px] bg-white rounded-4 text-groupBlue shadow-dropBig overflow-hidden max-w-[360px]">
      <View className="px-2 cursor-pointer relative">
        <View className="w-full h-[232px] rounded-2 border" />
      </View>
      <View className="flex justify-between px-2 blur-sm">
        <View>
          <Text fontSize={20} fontWeight="Bold">
            Harley Dawidson
          </Text>
          <Space y={1} />
          <Text>RBG 500</Text>
        </View>
        <LikedSvg className="cursor-pointer pt-1 w-8 h-8" variant={'liked'} />
      </View>
      <View className="flex justify-between pr-2 mt-1 blur-sm">
        <View className="shadow-insetSmall rounded-tr-2 rounded-br-2 flex items-center">
          <BuyNowSvg className="w-8 h-8 mx-2" />
        </View>
        <Price highestBet={120} yourHighestBet={400} buyNowPrice={0} tilesView />
      </View>
    </View>
  )
}

export default BrowseItemPlaceholder
